function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "accounts_svg__c",
  opacity: 1,
  d: "M4 6.5h1v7H4z"
}), React.createElement("path", {
  id: "accounts_svg__d",
  opacity: 1,
  d: "M7 6.5h1v7H7z"
}), React.createElement("path", {
  id: "accounts_svg__e",
  opacity: 1,
  d: "M10 6.5h1v7h-1z"
}), React.createElement("path", {
  id: "accounts_svg__f",
  opacity: 1,
  d: "M13 6.5h1v7h-1z"
}), React.createElement("path", {
  id: "accounts_svg__a",
  opacity: 1,
  d: "M1 15.5h16v3H1z"
}), React.createElement("path", {
  id: "accounts_svg__b",
  opacity: 1,
  d: "M2 13.5h14v3H2z"
}), React.createElement("path", {
  id: "accounts_svg__i",
  opacity: 1,
  fillRule: "evenodd",
  d: "M8.556.5L1 6.5h16L8.556.5z"
}), React.createElement("mask", {
  id: "accounts_svg__g",
  maskUnits: "userSpaceOnUse",
  maskContentUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, React.createElement("path", {
  d: "M0 0h18v18.5H0z"
}), React.createElement("use", {
  xlinkHref: "#accounts_svg__a",
  fill: "#fff"
})), React.createElement("mask", {
  id: "accounts_svg__h",
  maskUnits: "userSpaceOnUse",
  maskContentUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, React.createElement("path", {
  d: "M0 0h18v18.5H0z"
}), React.createElement("use", {
  xlinkHref: "#accounts_svg__b",
  fill: "#fff"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__c",
  fill: "#8395B7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__d",
  fill: "#8395B7"
});

var _ref5 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__e",
  fill: "#8395B7"
});

var _ref6 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__f",
  fill: "#8395B7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__a",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeWidth: 2,
  mask: "url(#accounts_svg__g)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__b",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeWidth: 2,
  mask: "url(#accounts_svg__h)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#accounts_svg__i",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeLinejoin: "round"
});

var SvgAccounts = function SvgAccounts(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 18.5,
    width: 18,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccounts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accounts.ddf02b77.svg";
export { ForwardRef as ReactComponent };